import { createAction, props } from '@ngrx/store';

export enum PolicyCancellationActions {
  ClearData = '[Flow Data Policy] Clear Cancellation Data',
  UpdatePolicyCancellation = '[Flow Data Policy] Update Cancellation Data',
  UpdateRethinkingCheckbox = '[Flow Data Policy] Update Rethinking Checkbox Cancellation Data',
  UpdateSaleCheckbox = '[Flow Data Policy] Update Sale Checkbox Cancellation Data',
  UpdatePolicyCancellationReasonDesc = '[Flow Data Policy] Update Cancellation Reason Desc Data',
}

export const UpdateRethinkingCheckbox = createAction(
  PolicyCancellationActions.UpdateRethinkingCheckbox,
  props<{ data: boolean }>()
);

export const UpdateSaleCheckbox = createAction(
  PolicyCancellationActions.UpdateSaleCheckbox,
  props<{ data: boolean }>()
);

export const UpdatePolicyCancellationReasonDesc = createAction(
  PolicyCancellationActions.UpdatePolicyCancellationReasonDesc,
  props<{ data: string }>()
);
